
import React, { useMemo } from "react";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import FilterComponent from "./FilterComponent";
import { format } from 'date-fns'; // 使用date-fns库进行日期格式化


const ProductsTable = props => {

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return format(date, 'yyyy-MM-dd HH:mm:ss');
  };


  const columns = [
    {
      name: <strong style={{ fontSize: '18px', textAlign: "center", width: "100%" }}>Name</strong>,
      selector: row => <div style={{ textAlign: "center" }}>{row.name}</div>,
    },
    {
      name: <strong style={{ fontSize: '18px', textAlign: "center", width: "100%" }}>Action</strong>,
      selector: row => <div style={{ textAlign: "center" }}>{row.action}</div>,
    },
  ];

  const handleChange = ({ selectedRows }) => {
    // You can set state or dispatch with something like Redux so we can use the retrieved data
   //console.log('Selected Rows: ', selectedRows);
  };
  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: 'ALL',
  };

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );
  const filteredItems = props.data.filter(
    item =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(filterText.toLowerCase()) !== -1
  );


  const handlePageChange = () => {
    // 这里添加切换页面的逻辑
    window.location.href = "/products/create";
  };

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <FilterComponent
          onFilter={e => setFilterText(e.target.value)}
          onClear={handleClear}
          filterText={filterText}
        />
        <Button onClick={handlePageChange} style={{ marginLeft: '10px' }}>
          Add
        </Button>
      </div>
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <>
      <DataTable
        pagination
        paginationPerPage={10}
        paginationComponentOptions={paginationComponentOptions}
        paginationRowsPerPageOptions={[10, 20, 30]}
        highlightOnHover
        // selectableRows
        columns={columns}
        data={filteredItems}
        onSelectedRowsChange={handleChange}
        subHeader
        subHeaderComponent={subHeaderComponent}
      />
    </>
  );
}

export default ProductsTable;